import request from '@/plugin/axios';

// 俱乐部等级查询
export function GetCtRound (id) {
  return request({
    url: request.adornUrl(
      `/weChat/referee/getCtRound/${
        id
      }`
    ),
    method: 'get',
  });
}

// 俱乐部公开赛场地管理查询
export function Query (params) {
  return request({
    url: request.adornUrl(
      '/ctCompetition/operation/against-list/competitionterrain/query'
    ),
    method: 'get',
    params: request.adornParams(params)
  });
}

// 俱乐部公开赛场地设置
export function Update (data) {
  return request({
    url: request.adornUrl(
      '/ctCompetition/operation/against-list/competitionterrain/update'
    ),
    method: 'post',
    data
  });
}
